module.exports = __webpack_public_path__ + "img/sticker-circle.6ddb2f7b.svg";